import { Form } from 'antd';
import React from 'react';
import cn from 'classnames';

import { Input } from '@atoms';

const QuestionnaireSupplyUnit = ({ ...rest }) => {
  return (
    <Form {...rest} className={cn('questionnaire', 'questionnaire-supply-unit')}>
      <Form.Item
        label="Тестовое поле 1"
        name="supply-unit-test-1"
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <Input.Enhanced placeholder="Впишите значение" />
      </Form.Item>
      <Form.Item
        label="Тестовое поле 2"
        name="supply-unit-test-2"
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <Input.Enhanced placeholder="Впишите значение" />
      </Form.Item>
    </Form>
  );
};

export default QuestionnaireSupplyUnit;
